module.exports = __webpack_public_path__ + "img/bot-avatar.f1287a49.svg";